import React, { ChangeEvent } from 'react';
import { Alert, Button, Grid, Snackbar } from '@mui/material';
import { styled } from '@mui/material/styles';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

interface ParsedObject {
  [key: string]: string;
}

const UploadCsv = ({ uploadedCsv, setUploadedCsv }: { uploadedCsv: any; setUploadedCsv: any }) => {
  const [error, setError] = React.useState<boolean>(false);

  const parseCSV = (text: string): ParsedObject[] => {
    const lines = text.split('\n');
    const headers = parseLine(lines[0]);

    const data = lines.slice(1).map(line => {
      const values = parseLine(line);
      const obj: ParsedObject = {};

      headers.forEach((header, index) => {
        obj[header] = values[index];
      });

      return obj;
    });

    return data;
  };

  const parseLine = (line: string): string[] => {
    const result: string[] = [];
    let current = '';
    let inQuotes = false;

    for (let i = 0; i < line.length; i++) {
      const char = line[i];

      if (char === '"' && (i === 0 || line[i - 1] !== '\\')) {
        inQuotes = !inQuotes;
      } else if (char === ',' && !inQuotes) {
        result.push(current.trim());
        current = '';
      } else {
        current += char;
      }
    }
    result.push(current.trim());
    return result;
  };

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];

    if (file && file.type === 'text/csv') {
      setError(false);
      const reader = new FileReader();
      reader.onload = e => {
        const text = e.target?.result as string;
        try {
          const json = parseCSV(text);
          setUploadedCsv(json);
          console.log(json);
        } catch (err) {
          setError(true);
        }
      };
      reader.readAsText(file);
    } else {
      setError(true);
      setUploadedCsv(null);
    }
  };

  return (
    <>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        sx={{ width: '100%', height: '100%', minHeight: '100vh', background: '#111' }}
      >
        <Grid container item direction="column" justifyContent="center" alignItems="center" xs={12}>
          <Button
            component="label"
            role={undefined}
            variant="contained"
            tabIndex={-1}
            startIcon={<CloudUploadIcon />}
            sx={{ color: '#fff', marginBottom: '20px' }}
          >
            Upload CSV
            <VisuallyHiddenInput type="file" onChange={handleFileChange} />
          </Button>

          {/* {localStorage.getItem('updated-market-csv') && (
            <Button component="label" variant="contained" tabIndex={-1} sx={{ color: '#fff' }}>
              Restore Previous Work
            </Button>
          )} */}
        </Grid>
      </Grid>
      <Snackbar
        open={error}
        autoHideDuration={6000}
        onClose={() => setError(false)}
        message="Please upload a valid CSV file"
      >
        <Alert
          onClose={() => setError(false)}
          severity="error"
          variant="filled"
          sx={{ width: '100%' }}
        >
          This is a success Alert inside a Snackbar!
        </Alert>
      </Snackbar>
    </>
  );
};

export default UploadCsv;
